<div class="error-page vh-100 d-flex flex-column align-items-center justify-content-center text-center">
    <div class="error-icon">
      <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    </div>
    <h1 class="error-code">404</h1>
    <p class="error-message">
      @if (isArabic) { عذرًا، الصفحة التي تبحث عنها غير موجودة. } @else { Sorry, the page you are looking for does not exist. }
    </p>
    <a routerLink="/home" class="btn btn-primary mt-4">
      @if (isArabic) { العودة إلى الصفحة الرئيسية } @else { Return to Home }
    </a>
</div>   